<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card>
        <v-card-text>
          <h2 class="title mb-3">{{ users.name01 }} {{ users.name02 }}様 / {{ users.name01_2 }} {{ users.name02_2 }}様</h2>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <div class="table__overflow elevation-1">
                <table class="datatable table">
                <tbody>
                  <tr>
                    <td>お客様ID</td>
                    <td class="text-xs-left">{{ users.customer_login_id }}</td>
                  </tr>
                  <tr>
                    <td>挙式日</td>
                    <td class="text-xs-left">{{ users.wedding_date | moment }}</td>
                  </tr>
                  <tr>
                    <td>挙式会場</td>
                    <td class="text-xs-left">{{ users.hall_name }}</td>
                  </tr>
                </tbody>
              </table>
              </div>
              <br>
              <!-- 使用回数についてのテーブルは一時非表示にいたします(2019/01/22)-->
              <!--<div class="table__overflow elevation-1">-->
                <!--<table class="datatable table">-->
                  <!--<tbody>-->
                  <!--<tr v-if="users.isum_flg">-->
                    <!--<td style="width:33%">ISUM使用回数</td>-->
                    <!--<td v-if="users.isum_limit" class="text-xs-left" style="width:50%">-->
                      <!--{{ $store.getters.getIsumTuneInPlayListCount }} / {{ users.isum_limit }} 回-->
                    <!--</td>-->
                    <!--<td v-else class="text-xs-left" style="width:50%">-->
                      <!--{{ $store.getters.getIsumTuneInPlayListCount }} / ∞ 回-->
                    <!--</td>-->
                  <!--</tr>-->
                  <!--<tr v-if="users.other_song_flg">-->
                    <!--<td style="width:33%">その他の曲使用回数</td>-->
                    <!--<td v-if="users.other_song_limit" class="text-xs-left" style="width:50%">{{ $store.getters.getOtherTuneInPlayListCount }} / {{ users.other_song_limit }} 回</td>-->
                    <!--<td v-else class="text-xs-left" style="width:50%">{{ $store.getters.getOtherTuneInPlayListCount }} / ∞ 回</td>-->
                  <!--</tr>-->
                  <!--</tbody>-->
                <!--</table>-->
              <!--</div>-->
            </v-flex>
            <v-flex xs12 md6 px-3 mt-2 v-if="playListCommit == false">
              <p class="primary--text">締め切り日：{{ users.deadline }}&nbsp;&nbsp;17:00</p>
              <p>下記のプレイリストの内容でよければ、プレイリスト決定ボタンを押してください。<br>一度決定するとキャンセルができないため慎重にお願いします。</p>
              <v-dialog v-model="dialog" persistent max-width="500">
                <v-btn slot="activator" color="info" dark>
                  <v-icon left dark>playlist_add</v-icon>
                  プレイリスト決定
                </v-btn>
                <v-card>
                  <v-card-title class="headline">プレイリストを決定しますか？</v-card-title>
                  <v-card-text>
                    <p>作成したプレイリストの内容で間違いがないかご確認のうえ、確定される場合は決定ボタンを押してください。</p>
                    <v-alert outline color="error" icon="warning" :value="commitError1">
                      進行プレイリストに曲未選択の項目があります。
                    </v-alert>
                    <v-alert outline color="error" icon="warning" :value="commitError2">
                      進行プレイリストの曲が25曲をオーバーしています。
                    </v-alert>
                    <v-alert outline color="error" icon="warning" :value="commitError3">
                      歓談プレイリストの曲が10曲選択されていません。
                    </v-alert>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat @click.native="commitCancel()">キャンセル</v-btn>
                    <v-btn color="green darken-1" flat @click.native="completeCustomerList()">決定</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
            <v-flex xs12 md6 px-3 mt-2 v-else>
              <p class="primary--text">締め切り日：{{ users.deadline }}&nbsp;&nbsp;17:00</p>
              <p>お客様のプレイリストはすでに確定されています。</p>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import CustomerPlayListService from '@/components/services/CustomerPlayListService.vue'
import UserService from '@/components/services/UserService.vue'
import moment from 'moment'
export default {
  data () {
    return {
      users: {
        other_song_flg: 'false',
        isum_flg: 'false',
        isum_limit: 0,
        other_song_limit: 0
      },
      // boolean true: プレイリスト確定済み false: 未確定
      playListCommit: false,
      dialog: false,
      commitError1: false,
      commitError2: false,
      commitError3: false
    }
  },
  created () {
    this.getCustomerInfo()
    this.isPlayListCommitted()
  },
  computed: {
    canUseIsumTune () {
      return this.users.isum_flg
    },
    canUseOtherTune () {
      return this.users.other_song_flg
    }
  },
  methods: {
    /**
     * 新郎新婦情報を取得
     **/
    async getCustomerInfo () {
      let transactionId = this.$store.state.transactionId
      await UserService.findCustomer(transactionId, (response) => {
        this.$store.commit('setCustomerInfo', response)
        this.users = response
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * プレイリストが確定済みかを確認する
     **/
    isPlayListCommitted () {
      const transactionId = this.$store.state.transactionId
      UserService.getPlayListCommitStatus(transactionId, (response) => {
        this.playListCommit = response
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * 顧客プレイリストを決定する
     **/
    completeCustomerList () {
      this.logging('methods: completeCustomerList')
      let formData = new URLSearchParams()
      formData.append('transactionid', this.$store.state.transactionId)
      for (let index in this.$store.state.playlist_a) {
        if (this.$store.state.playlist_a[index]['product_id'] === null) {
          this.commitError1 = true
          return
        }
      }
      if (this.$store.state.playlist_a.length > this.$store.getters.getTuneLimit) {
        this.commitError2 = true
        return
      }
      // 歓談楽曲が10曲選択されているかを確認する
      for (let index in this.$store.state.playlist_b) {
        if (this.$store.state.playlist_b[index]['product_id'] === null) {
          this.commitError3 = true
          return
        }
      }

      CustomerPlayListService.completeCustomerPlayList(formData, (response) => {
        this.isPlayListCommitted()
        this.dialog = false
        location.reload()
      }, (error) => {
        this.logging(error)
      })
    },
    commitCancel () {
      this.dialog = false
      this.commitError1 = false
      this.commitError2 = false
      this.commitError3 = false
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue